import { SearchResults } from "../../../types/search/search-results.interface";
import { IProductDetail } from "../../../types/product/iproduct-detail.interface";
import { Observable } from "rxjs";
import * as http from "../../../services/http.service";

export function searchProducts(searchTerm: string): Observable<SearchResults<IProductDetail>> {
  return http.get(getEndPoint(searchTerm));
}

function getEndPoint(searchTerm: string): string {
  return `/search/products-simplified/?q=${searchTerm}`;
}
